<style>
.notification {
  padding: 1rem;
}
</style>
<template>
  <div id="app">
    <router-view />
  </div>
  <notifications position="top right" class="notification" />
</template>

<script>
import authService from "./services/authService";

export default {
  name: "App",
  computed: {
    isAuthenticated() {
      return !!authService.getAccessToken();
    },
  },
  methods: {
    handleLogout() {
      authService.logout();
      this.$router.push("/login");
    },
  },
};
</script>
